import styled from 'styled-components';

export const Container = styled.div`
    border-radius: 8px;
    width: 410px;
    height: 270px;
    box-shadow: 0 0 0 500px rgba(0, 0, 0, 0.6);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    &.selfie {
        width: 270px;
        height: 270px;
        border: 2px solid ${(props) => props.theme.palette.primaryA7};
        border-radius: 50%;

        &.success {
            border-color: ${(props) => props.theme.palette.secondaryA3};
        }

        &.error {
            border-color: ${(props) => props.theme.palette.secondaryA4};
        }

        &.loading {
            border-color: ${(props) => props.theme.palette.primaryA1};
        }
    }
`;

export const Line = styled.div`
    position: absolute;
    color: ${(props) => props.theme.palette.primaryA7};
    &.success {
        color: ${(props) => props.theme.palette.secondaryA3};
    }
    &.error {
        color: ${(props) => props.theme.palette.secondaryA4};
    }
    &.loading {
        color: ${(props) => props.theme.palette.primaryA1};
    }
    &:first-child {
        right: -1px;
        top: -1px;
    }
    &:nth-child(2) {
        transform: rotate(270deg);
        left: 0;
        top: -3px;
    }
    &:nth-child(3) {
        transform: rotate(180deg);
        left: -1px;
        bottom: -1px;
    }
    &:nth-child(4) {
        transform: rotate(90deg);
        right: 0;
        bottom: -1px;
    }
`;
